import { faEarthAmericas, faUser, faFolder, faCalendarDays } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Link } from 'react-router-dom';
import { Proceso } from 'data/project-management/procesos';
import { useChatWidgetContext } from 'providers/ChatWidgetProvider'; // Ajusta el path

const ProcesoDetailsSummary = (data: Proceso) => {
  

  return (
    <div className="d-flex flex-wrap gap-4 text-body fs-9 mt-2">
      {/* Fuero / Órgano Judicial */}
      <div className="d-flex align-items-center">
        <FontAwesomeIcon icon={faEarthAmericas} className="me-2 text-body-tertiary" />
        <span className="fw-bold me-1">Radicación:</span>
        <span className="text-body-secondary">{data.OJUD}</span>
      </div>

      {/* Expediente */}
      <div className="d-flex align-items-center">
        <FontAwesomeIcon icon={faUser} className="me-2 text-body-tertiary" />
        <span className="fw-bold me-1">Expte:</span>
        <span className="text-body-secondary">{data.EXP1}</span>
      </div>

      {/* Carpeta */}
      <div className="d-flex align-items-center">
        <FontAwesomeIcon icon={faFolder} className="me-2 text-body-tertiary" />
        <span className="fw-bold me-1">Carpeta:</span>
        <span className="text-body-secondary">{data.CARP}</span>
      </div>

      {/* Responsable */}
      <div className="d-flex align-items-center">
        <FontAwesomeIcon icon={faUser} className="me-2 text-body-tertiary"/>
        <span className="fw-bold me-1">Responsable:</span>
        <span className="text-body-secondary">{data.MIEM}</span>
      </div>

      {/* Actor */}
      <div className="d-flex align-items-center">
        <FontAwesomeIcon icon={faUser} className="me-2 text-body-tertiary" />
        <span className="fw-bold me-1">Actor:</span>
        <Link className="fw-semibold d-block lh-sm" to={`/app/apps/crm/persona-details/${data.ACTOR}`}>
          {data.ACTO}
        </Link>
      </div>

      {/* Demandado */}
      <div className="d-flex align-items-center">
        <FontAwesomeIcon icon={faUser} className="me-2 text-body-tertiary" />
        <span className="fw-bold me-1">Dddo:</span>
        <span className="text-body-secondary">{data.DEMA}</span>
      </div>

      {/* Fecha Inicio */}
      <div className="d-flex align-items-center">
        <FontAwesomeIcon icon={faCalendarDays} className="me-2 text-body-tertiary" />
        <span className="fw-bold me-1">Fecha:</span>
        <span className="text-body-tertiary text-opacity-85 fw-semibold">{data.INIC}</span>
      </div>
    </div>
  );
};

export default ProcesoDetailsSummary;